export class SaveInfo {
    savePw: string;
    savePwConfirm: string;
}
